import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import { logoutSuccess } from "./index";
export const logoutUser = () => async (dispatch) => {
  let token = localStorage.token;
  localStorage.clear();
  setAuthToken(false);
  dispatch(logoutSuccess(false));
  if(token){
    try {
      await axios.get(`${process.env.REACT_APP_BASE_URL}api/users/logout`, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });
    } catch (err) {
      console.log(err);
    }
  }
};
